import { render, staticRenderFns } from "./SuggestionModal.vue?vue&type=template&id=f2fd9218"
import script from "./SuggestionModal.vue?vue&type=script&lang=js"
export * from "./SuggestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports